import { down, up } from 'styled-breakpoints'
import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  gap: 25px;
  padding: 15px;
  width: 100%;
  background-color: #efefef;
  ${up('md')} {
    justify-content: center;
    flex-direction: row;
    align-items: center;
  }
`

export const Message = styled.div`
  font-size: 60px;
  color: ${({ theme }) => theme.colors.primary};
`

export const HomeStyles = {
  Row: styled.div``,
  ContentInner: styled.div``,
  Label: styled.div``,
}

export const FilterStyles = {
  Content: styled.div`
    padding: 15px;
    display: flex;
    gap: 15px;
    width: 100%;
    flex-direction: column;
    align-items: center;
  `,
  Title: styled.div`
    color: ${({ theme }) => theme.colors.primary};
    font-size: 22px;
    font-style: normal;
    font-weight: 800;
    line-height: normal;
  `,
}
export const ChartStyle = {
  Content: styled.div`
    height: fit-content;
    width: 33%;
    ${down('md')} {
      width: 100%;
    }
  `,
}

export const ChartTitle = styled.div`
  color: ${({ theme }) => theme.colors.primary};
  font-size: 18px;
  text-align: center;
  border: none;
  padding: 25px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.primary};
`

export const DashStyles = {
  LeftPanel: styled.div`
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    border-radius: 25px;
    background-color: white;
    width: 75%;
    height: 100%;
    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
    ${down('md')} {
      width: 100%;
      height: fit-content;
    }
  `,
  RightPanel: styled.div<{ hidden: boolean }>`
    width: 25%;
    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
    height: 100%;
    ${down('md')} {
      width: 100%;
    }
    ${({ hidden }) => hidden && `display: none`}
    border-radius: 25px;
    background-color: white;
  `,
  Label: styled.div``,
}
